<nz-drawer
  [nzVisible]="visible"
  [nzTitle]="drawerTitle"
  [nzWidth]="800"
  [nzClosable]="true"
  [nzMaskClosable]="false"
  (nzOnClose)="onCancel()">
  
  <ng-container *nzDrawerContent>
    <div class="event-editor-container">
      
      <!-- Mode Selector -->
      <div class="mode-selector">
        <nz-radio-group [(ngModel)]="currentMode" (ngModelChange)="onModeChange($event)">
          <label nz-radio-button nzValue="simple">
            <nz-icon nzType="appstore" nzTheme="outline"></nz-icon>
            Modo Simples
          </label>
          <label nz-radio-button nzValue="expert">
            <nz-icon nzType="code" nzTheme="outline"></nz-icon>
            Modo Expert
          </label>
        </nz-radio-group>

        <nz-tag [nzColor]="eventType === 'onChange' ? 'blue' : 'green'">
          {{ eventType === 'onChange' ? 'Ao Mudar' : 'Ao Inicializar' }}
        </nz-tag>
      </div>

      <!-- Simple Mode -->
      <div class="mode-content" *ngIf="currentMode === 'simple'">
        <app-simple-mode
          [componentNode]="componentNode"
          [canvasContext]="canvasContext"
          [eventConfig]="currentEventConfig"
          [eventType]="eventType"
          (configCreated)="onSimpleModeConfig($event)">
        </app-simple-mode>
      </div>

      <!-- Expert Mode -->
      <div class="mode-content" *ngIf="currentMode === 'expert'">
        <app-expert-mode
          [eventConfig]="currentEventConfig"
          (configChanged)="onExpertModeConfig($event)">
        </app-expert-mode>
      </div>

      <!-- Footer Actions -->
      <div class="drawer-footer">
        <button nz-button nzType="default" (click)="onCancel()">
          Cancelar
        </button>
        <button 
          nz-button 
          nzType="primary" 
          (click)="onSave()"
          [disabled]="!canSave()">
          <nz-icon nzType="save" nzTheme="outline"></nz-icon>
          Salvar Evento
        </button>
      </div>
    </div>
  </ng-container>
</nz-drawer>



